function escapeCSVValue (value) {
  return `${value}`.replace(/"/g, '""')
}

export async function exportToCsv ({
  uri,
  columnNames,
  mapper,
  filenamePrefix,
  user,
  error,
  onError,
  onProgress,
  cancelRef
}) {
  if (error != null) {
    onError(null)
  }

  const data = [columnNames]
  const batchSize = 1000

  async function fetchBatch (batch) {
    try {
      const token = await user.getIdToken()
      const response = await fetch(`${uri}&limit=${batchSize}&offset=${(batch - 1) * batchSize}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      if (response.status !== 200) {
        throw new Error(`Unexpected status from exportToExcel (${uri}): ${response.status}`)
      } else {
        const rowCount = parseInt(response.headers.get('count'))
        const json = await response.json()
        if (onProgress != null) { onProgress((batch - 1) * batchSize / rowCount * 100) }
        if (cancelRef?.current) {
          return false // cancelled
        } else if (json.length === 0) {
          return true // success
        } else {
          data.push(...mapper(json))
          return await fetchBatch(batch + 1)
        }
      }
    } catch (e) {
      onError({ message: 'Error fetching data. Please try again later.' })
      console.error(e)
      return false // failure
    }
  }

  const success = await fetchBatch(1)

  if (cancelRef?.current) {
    cancelRef.current = false
    if (onProgress != null) { onProgress(null) }
  }

  if (!success) {
    return null
  }

  if (onProgress != null) { onProgress(null) } // Dismiss progress bar (we're done!)

  const now = new Date()
  const year = now.getFullYear()
  const month = (now.getMonth() + 1).toString().padStart(2, '0')
  const date = now.getDate().toString().padStart(2, '0')
  const dateString = `${year}-${month}-${date}`
  const fileName = `${filenamePrefix}_${dateString}.csv`

  const content = []

  for (const row of data) {
    const line = []
    for (const column of row) {
      if (column == null) {
        line.push('')
      } else if (Array.isArray(column)) {
        line.push(`"${column.map(x => `${escapeCSVValue(x)}`).join(';')}"`)
      } else {
        line.push(`"${escapeCSVValue(column)}"`)
      }
    }
    content.push(line)
  }

  const rows = content.map(row => row.join(',')).join('\n')
  const blob = new Blob([rows], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.setAttribute('href', url)
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
}
